import { useField } from 'react-final-form';
import Header from '../../../../shared/Header';

const NameHeader = ({ name, title }) => {
  const field = useField(name);
  const fieldValue = field?.input?.value;
  const fieldTitle = fieldValue && typeof fieldValue === 'string' ? fieldValue : '';
  return <Header title={fieldTitle || title} />;
};

export default NameHeader;
